<template>
  <v-container>
    <v-tabs v-model="tabs">
    <v-tab>Daily visualisation</v-tab>
    <v-tab>Rain events visualisation</v-tab>
    <v-tab>Long-term monitoring</v-tab>

    <v-tab-item>
      <v-container style="padding:25px 0px 25px 0px;">
      <v-row class="text-center">
      <v-col cols="6" style="padding:0px 10px 0px 20px; margin:0px;">
        <v-select
          :items="sites"
          v-model="site"
          label="Select site"
          dense
          solo
          prepend-icon="mdi-map-marker-radius-outline"
        ></v-select>
      </v-col>
      <v-col cols="6" style="padding:0px 20px 0px 10px; margin:0px;">
        <v-select
          v-model="radar"
          :items="radars"
          item-text="radar_pid_disdro"
          item-value="radar_pid_disdro"
          label="Select radar type / disdro type"
          dense
          solo
          prepend-icon="mdi-satellite-uplink"
          @change="changeRadar()"
          return-object
          single-line
        ></v-select>
      </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" style="padding:0px 10px 0px 20px; margin:0px;">
          <v-date-picker show-adjacent-months v-model="selectedDate" @change="displayQLs()" elevation="5" 
            full-width
            :max="nowDate"
            :allowed-dates="allowedDates"
            class="mt-4"
            style="padding:0px; margin:0px;"
            ></v-date-picker>
          <v-card
            elevation="5"
            v-if="radar !== null"
            style="margin-top:10px"
          >
            <v-list dense>
              <v-subheader>Information</v-subheader>
              <v-list-item-group
                color="primary"
              >
                <v-list-item>
                  <v-list-item-icon style="margin-right:0px">
                    <v-icon small>mdi-information</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <small>Radar: <a :href="radar.radar_pid" target="_blank">{{ radar.radar_type }}</a></small>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon style="margin-right:0px">
                    <v-icon small>mdi-information</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <small>Disdro: <a :href="radar.disdro_pid" target="_blank">{{ radar.disdro_type }}</a></small>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <v-divider></v-divider>
              <v-subheader>Download related data</v-subheader>
              <v-list-item-group
                color="primary"
                v-if="outputFiles.length>0"
              >
                <v-list-item
                  v-for="(item, i) in outputFiles"
                  :key="i"
                >
                  <v-list-item-icon style="margin-right:0px">
                    <v-icon small>mdi-download</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <small>{{item.type}} file: <a :href="item.url" target="_blank">{{item.text}}</a></small>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <v-list-item-group
                color="primary"
                v-else
              >
                <v-list-item
                >
                  <v-list-item-content>
                    <small>No data for this day</small>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="9" style="padding:0px 20px 0px 10px; margin:0px;">
          <v-card elevation="5">
          <div v-if="noData">    
            <v-alert  prominent outlined  border="left" type="warning" style="margin-top:16px" >
              There is no data for this day.
            </v-alert>
          </div>
          <div v-else>
            <div v-for="(item, i) in outputQLs" :key="i">
              <a :href="item.url" target="_blank">
                <v-img :src="item.url" :title="item.type">
                </v-img>
              </a>
            </div>
          </div>
        </v-card>
        </v-col>
      </v-row>
    </v-container>
    </v-tab-item>





    
    <v-tab-item>

      <v-row class="text-center" style="padding:25px 0px 0px 0px;">
      <v-col cols="6" style="padding:0px 10px 0px 20px; margin:0px;">
        <v-select
          :items="sites"
          v-model="site"
          label="Select site"
          dense
          solo
            prepend-icon="mdi-map-marker-radius-outline"
        ></v-select>
      </v-col>
      <v-col cols="6" style="padding:0px 20px 0px 10px; margin:0px;">
        <v-select
          v-model="radar"
          :items="radars"
          item-text="radar_pid_disdro"
          item-value="radar_pid_disdro"
          label="Select radar type / disdro type"
          dense
          solo
          prepend-icon="mdi-satellite-uplink"
          @change="changeRadar2()"
          return-object
          single-line
        ></v-select>
      </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" style="padding:0px 10px 0px 20px; margin:0px;">
          <v-date-picker show-adjacent-months v-model="selectedDate" @change="displayQLs2()" elevation="5" 
            full-width
            :max="nowDate"
            :allowed-dates="allowedDates"
            class="mt-4"
            style="padding:0px; margin:0px;"
            ></v-date-picker>
          <v-card
            elevation="5"
            v-if="radar !== null"
            style="margin:10px 0px 20px 0px"
          >
            <v-list dense>
              <v-subheader>Information</v-subheader>
              <v-list-item-group
                color="primary"
              >
                <v-list-item>
                  <v-list-item-icon style="margin-right:0px">
                    <v-icon small>mdi-information</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <small>Radar: <a :href="radar.radar_pid" target="_blank">{{ radar.radar_type }}</a></small>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon style="margin-right:0px">
                    <v-icon small>mdi-information</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <small>Disdro: <a :href="radar.disdro_pid" target="_blank">{{ radar.disdro_type }}</a></small>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <v-divider></v-divider>
              <v-subheader>Download related data</v-subheader>
              <v-list-item-group
                color="primary"
                v-if="outputFiles2.length>0"
              >
                <v-list-item
                  v-for="(item, i) in outputFiles2"
                  :key="i"
                >
                  <v-list-item-icon style="margin-right:0px">
                    <v-icon small>mdi-download</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <small>{{item.type}} file: <a :href="item.url" target="_blank">{{item.text}}</a></small>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <v-list-item-group
                color="primary"
                v-else
              >
                <v-list-item
                >
                  <v-list-item-content>
                    <small>No data for this day</small>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="9" style="padding:0px 20px 0px 10px; margin:0px;">
          <div v-if="noData2">    
            <v-alert  prominent outlined  border="left" type="warning" style="margin-top:16px" >
              There is no quicklook for this day (none rain event).
            </v-alert>
        </div>
        <div v-else>
          <div v-for="(item, i) in outputQLs2" :key="i">
            <a :href="item.url" target="_blank"><v-img :src="item.url" :title="item.type">
            </v-img></a>
          </div>
        </div>
        </v-col>
      </v-row>
</v-tab-item>



<v-tab-item>
  <v-container style="padding:25px 0px 25px 0px;">
      <v-row class="text-center">
      <v-col cols="12" style="padding:0px 20px 0px 20px; margin:0px;">
        <v-select
          :items="sites"
          v-model="site"
          label="Select site"
          dense
          solo
          prepend-icon="mdi-map-marker-radius-outline"
        ></v-select>
      </v-col>
      </v-row>
      <v-row>
        
        <v-col cols="12" style="padding:0px 20px 0px 20px; margin:0px;">
          <v-card elevation="5">
          <div v-if="noData3">    
            <v-alert  prominent outlined  border="left" type="warning" style="margin-top:16px" >
              There is no quicklook for this site.
            </v-alert>
          </div>
          <div v-else>
            <div v-for="(item, i) in hrefsPNG" :key="i">
              <a :href="'https://data.ipsl.fr/repository/ccres/calib_monitor/'+item" target="_blank">
                <v-img :src="'https://data.ipsl.fr/repository/ccres/calib_monitor/'+item" :title="item"></v-img>
              </a>
            </div>
          </div>
        </v-card>
        </v-col>
      </v-row>
    </v-container>
</v-tab-item>
  </v-tabs>
  
    
  </v-container>
</template>

<script>
import axios from 'axios';


  export default {
    name: 'ccres-visu',

    data: () => ({
      disdroURL: "https://data.ipsl.fr/repository/ccres/disdro/",
      ccresdata: null,
      site: "",
      radar: null,
      radars: [],
      sites: [],
      selectedDate: null,
      nowDate: null,
      outputFiles: [],
      outputQLs: [],
      outputFiles2: [],
      outputQLs2: [],
      noData: false,  
      noData2: false,   
      noData3: false,      
      tabs: 0,
      arrayDates: [],
      loading: false,
      hrefsPNG: []
    }),
    created() {
    },
    mounted() {
      this.getCCRESConfig();

      // Créer une nouvelle instance de Date
      var date = new Date();
      date.setDate(date.getDate() - 1);

      // Obtenez l'année, le mois et le jour
      var year = date.getUTCFullYear();
      var month = ('0' + (date.getUTCMonth() + 1)).slice(-2); // Ajouter 1 car les mois commencent à 0
      var day = ('0' + date.getUTCDate()).slice(-2);

      // Créer la date au format YYYY-MM-DD
      this.nowDate = year + '-' + month + '-' + day;
      this.selectedDate = year + '-' + month + '-' + day;
    },

    watch: {
      tabs: function (newVal, oldVal) {
        console.log('tabs:  ' + newVal+' '+oldVal)
        this.changeSite() 
      },
      ccresdata: function (newVal, oldVal) {
        console.log('ccresdata:  '+newVal+' '+oldVal)
        for (let i = 0; i < this.ccresdata.length; i++) {
          this.sites.push( this.ccresdata[i].site)
        }
      },
      site: function (newVal, oldVal) {
        console.log('site:  ' + newVal+' '+oldVal)
        this.changeSite() 
      },
      loading: function (newVal, oldVal) {
        console.log('site:  ' + newVal+' '+oldVal)
        if(this.loading)
            document.body.style.cursor = 'wait'
        else
          document.body.style.cursor = 'default'
      }
    },

    methods: {
      changeSite() {
        console.log('changesite')
        this.radars = []
        this.radar = null
        this.outputFiles= []
        this.outputQLs= []
        this.noData = false
        this.outputFiles2= []
        this.outputQLs2= []
        this.noData2 = false
        this.arrayDates = []
        this.hrefsPNG = []
          switch(this.tabs) {
            case 0:            
              axios
                .get('https://ccres.ipsl.fr/api/v1/daily/'+this.site+'?format=json')
                .then(response => {
                  if(response.data.length>0) {
                    this.radars = response.data
                    this.radar = this.radars[0]
                    this.changeRadar()
                  }
                })
                .catch(error => {
                  console.log(error)
                })
                .finally()
              break;
            case 1:
              axios
                .get('https://ccres.ipsl.fr/api/v1/rain/'+this.site+'?format=json')
                .then(response => {
                  if(response.data.length>0) {
                    this.radars = response.data
                    this.radar = this.radars[0]
                    this.changeRadar2()
                  }
                })
                .catch(error => {
                  console.log(error)
                })
                .finally()
              break;
            case 2:

              if(this.site != "") {
                axios
                  .get('https://data.ipsl.fr/repository/ccres/calib_monitor/')
                  .then(response => {
                    // Crée un élément temporaire pour parser le HTML
                    const div = document.createElement('div');
                    div.innerHTML = response.data;

                    // Récupère tous les éléments <a> dans le contenu HTML
                    const liens = div.querySelectorAll('a');
                    
                    // Extrait les attributs href de chaque lien et les met dans un tableau
                    this.hrefsPNG = Array.from(liens)
                        .map(lien => lien.getAttribute('href'))
                        .filter(href => href && href.includes('.png') && href.includes(this.site))
                  })
                  .catch(error => {
                    console.log(error)
                  })
                }
                break;
          }      
      },
      allowedDates(val) {
          if (this.arrayDates.includes(val))
            return val
      },
      getCCRESConfig() {
        axios.get(this.disdroURL + "ccres_disdro_processing_conf.json").then(json => (this.ccresdata = json.data));            
      },
      changeRadar() {
        console.log('changeRadar')
        this.arrayDates = []
        axios
          .get('https://ccres.ipsl.fr/api/v1/daily/'+this.site+'/'+this.radar.radar_pid_disdro+'?format=json')
          .then(json => {
            if(json.data.length > 0) {
              this.selectedDate = json.data[json.data.length - 1].date
              this.displayQLs()
              for (var i = 0; i < json.data.length; i++) {
                this.arrayDates.push(json.data[i].date)
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally()
      },
      changeRadar2() {
        console.log('changeRadar2')
        this.arrayDates = []
        axios
          .get('https://ccres.ipsl.fr/api/v1/rain/'+this.site+'/'+this.radar.radar_pid_disdro+'?format=json')
          .then(json => {
            if(json.data.length > 0) {
              this.selectedDate = json.data[json.data.length - 1].date
              this.displayQLs2()
              for (var i = 0; i < json.data.length; i++) {
                this.arrayDates.push(json.data[i].date)
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally()
      },
      displayQLs() {
        console.log('displayQLs')
        if(this.radar === null || this.site=='') {
          alert('Select a site and a radar configuration!')
        }
        else {
          this.outputFiles = []
          this.outputQLs = []
          this.loading = true
          axios
            .get('https://ccres.ipsl.fr/api/v1/daily/'+this.site+'/'+this.radar.radar_pid_disdro	+'/'+this.selectedDate+'?format=json')
            .then(json => {
              for (let i = 0; i < json.data.files.length; i++) {
                let ds = this.selectedDate.split('-');
                
                let outputFile = {text:'', url: '', type: ''}
                let tmp = json.data.files[i]
                outputFile.url = this.disdroURL + this.site + '/' + ds[0] + '/' + ds[1] + '/' + ds[2] + '/' + tmp;
                
                outputFile.text = tmp;

                if(tmp.indexOf('.png') > 0) {
                  outputFile.type = "png"  
                  this.outputQLs.push(outputFile)    
                }
                else {
                  outputFile.type = "data"
                  this.outputFiles.push(outputFile)  
                }    
              }
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => this.loading = false)
        }
      },
      displayQLs2() {
        console.log('displayQLs2')
        if(this.radar == '' || this.site=='') {
          alert('Select a site and a radar configuration!')
        }
        else {
          this.outputFiles2 = []
          this.outputQLs2 = []
          this.loading = true
          axios
            .get('https://ccres.ipsl.fr/api/v1/rain/'+this.site+'/'+this.radar.radar_pid_disdro+'/'+this.selectedDate+'?format=json')
            .then(json => {
              
              for (let i = 0; i < json.data.files.length; i++) {
                let ds = this.selectedDate.split('-');
                
                let outputFile = {text:'', url: '', type: ''}
                let tmp = json.data.files[i]
                outputFile.url = this.disdroURL + this.site + '/' + ds[0] + '/' + ds[1] + '/' + ds[2] + '/' + tmp;
                
                outputFile.text = tmp;

                if(tmp.indexOf('.png') > 0) {
                  outputFile.type = "png"  
                  this.outputQLs2.push(outputFile)    
                }
                else {
                  outputFile.type = "data"
                  this.outputFiles2.push(outputFile)  
                }    
              }
              if(this.outputQLs2.length == 0)
                this.noData2 = true
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => this.loading = false)
        }
      },
      /*
      // Fonction pour vérifier si le fichier existe
      async  verifierExistenceFichier(url) {
          try {
              const response = await axios.head(url);
              // Si le statut de réponse est 200, le fichier existe
              if (response.status === 200) {
                  console.log('Le fichier existe en ligne.');
                  this.noData = false;
              } else {
                  console.log('Le fichier n\'existe pas en ligne.');
                  this.outputFiles = [];
                  this.outputQLs = [];
                  this.noData = true;
              }
          } catch (error) {
              // En cas d'erreur (ex : 404), le fichier n'existe probablement pas
              console.error('Erreur lors de la vérification de l\'existence du fichier :', error.message);
              this.outputFiles = [];
              this.outputQLs = [];
              this.noData = true;
          }
      },*/
      
    }
  }
</script>
